/* eslint-disable @typescript-eslint/no-unused-vars */
// non utilisé pour le moment
import { DagreClusterLayout, DagreSettings, Edge, Graph, Orientation } from '@swimlane/ngx-graph';
import * as dagre from 'dagre';

export interface PegaseLayoutSettings extends DagreSettings {
    curveDistance?: number;
}

const DEFAULT_EDGE_NAME = '\x00';
const GRAPH_NODE = '\x00';
const EDGE_KEY_DELIM = '\x01';

export class CustomPegaseLayout extends DagreClusterLayout {
    defaultSettings: PegaseLayoutSettings = {
        orientation: Orientation.LEFT_TO_RIGHT,
        marginX: 10,
        marginY: 10,
        edgePadding: 100,
        rankPadding: 150,
        nodePadding: 50,
        curveDistance: 20,
        multigraph: false,
        compound: true
    };
    settings: PegaseLayoutSettings = {};

    public run(graph: Graph): Graph {
        this.createDagreGraph(graph);
        dagre.layout(this.dagreGraph);

        graph.edgeLabels = this.dagreGraph._edgeLabels;

        for (const dagreNodeId in this.dagreGraph._nodes) {
            const dagreNode = this.dagreGraph._nodes[dagreNodeId];
            const node = graph.nodes.find(n => n.id === dagreNode.id);
            if (node) {
                node!.position = {
                    x: dagreNode.x,
                    y: dagreNode.y
                };
                node!.dimension = {
                    width: dagreNode.width,
                    height: dagreNode.height
                };
            } else {
                const cluster = graph.clusters?.find(c => c.id === dagreNode.id);
                if (cluster) {
                    cluster!.position = {
                        x: dagreNode.x,
                        y: dagreNode.y
                    };
                    cluster!.dimension = {
                        width: dagreNode.width,
                        height: dagreNode.height
                    };
                }
            }
        }
        for (const edge of graph.edges) {
            this.updateEdge(graph, edge);
        }

        return graph;
    }

    public updateEdge(graph: Graph, edge: Edge): Graph {
        const sourceNode = graph.nodes.find(n => n.id === edge.source);
        const targetNode = graph.nodes.find(n => n.id === edge.target);
        const rankAxis: 'x' | 'y' = this.settings.orientation === 'BT' || this.settings.orientation === 'TB' ? 'y' : 'x';
        const orderAxis: 'x' | 'y' = rankAxis === 'y' ? 'x' : 'y';
        const rankDimension = rankAxis === 'y' ? 'height' : 'width';
        // determine new arrow position
        const dir = sourceNode!.position![rankAxis] <= targetNode!.position![rankAxis] ? -1 : 1;
        const startingPoint = {
            [orderAxis]: sourceNode!.position![orderAxis],
            [rankAxis]: sourceNode!.position![rankAxis] - dir * (sourceNode!.dimension![rankDimension] / 2)
        };
        const endingPoint = {
            [orderAxis]: targetNode!.position![orderAxis],
            [rankAxis]: targetNode!.position![rankAxis] + dir * (targetNode!.dimension![rankDimension] / 2)
        };

        const curveDistance = this.settings.curveDistance || this.defaultSettings.curveDistance;
        // generate new points
        edge.points = [
            startingPoint,
            {
                [rankAxis]: (startingPoint[rankAxis] + endingPoint[rankAxis]) / 2,
                [orderAxis]: startingPoint[orderAxis]
            },
            {
                [orderAxis]: endingPoint[orderAxis],
                [rankAxis]: (startingPoint[rankAxis] + endingPoint[rankAxis]) / 2
            },
            endingPoint
        ];
        const edgeLabelId = `${edge.source}${EDGE_KEY_DELIM}${edge.target}${EDGE_KEY_DELIM}${DEFAULT_EDGE_NAME}`;
        const matchingEdgeLabel = graph.edgeLabels[edgeLabelId];
        if (matchingEdgeLabel) {
            matchingEdgeLabel.points = edge.points;
        }
        return graph;
    }
}
